"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Checkmark = function (_a) {
    var indeterminate = _a.indeterminate, className = _a.className;
    if (indeterminate) {
        return (react_1.default.createElement("svg", { className: className, width: "12", height: "4", viewBox: "0 0 12 4", fill: "none" },
            react_1.default.createElement("rect", { y: "0.75", width: "12", height: "2.5", rx: "1.25", fill: "white" })));
    }
    return (react_1.default.createElement("svg", { className: className, width: "14", height: "11", viewBox: "0 0 14 11", fill: "none" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.92212 8.44873L12.3708 1L13.3596 1.98877L4.92212 10.4263L1 6.50415L1.98877 5.51538L4.92212 8.44873Z", fill: "white", stroke: "white", strokeLinejoin: "round" })));
};
exports.default = Checkmark;
